import {
  faArrowRight,
  faEdit,
  faTrash,
} from "@fortawesome/fontawesome-free-solid";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Button from "../../Component/Button/Button";
import Modal from "../../Component/Modal/Modal";
import "react-toastify/dist/ReactToastify.css";
import "./change.css";
import Style from "./ChangeAddress.module.css";
import { errorToast, succToast } from "../../Toast/Toast";
import LoadingComponet from "../../Component/LoadingComponet/LoadingComponet";
import {
  AddressList,
  getCurrent,
  RemoveAddress,
  selectAddress,
} from "../../Api/BarestServices";

const ChangeAddress = () => {
  const history = useHistory();
  const [Locations, setLocations] = useState();
  const [currentLocations, setCurrentLocations] = useState("1");
  const [IdRemove, setIdRemove] = useState();
  const [Mapid, setMapid] = useState(currentLocations);
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    showData();
    CurrentAddres();
  }, []);
  const showData = async () => {
    AddressList((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
        } else {
          setLocations(res.addresses);
        }
      } else {
        console.error(res);
      }
    });
  };
  const CurrentAddres = async () => {
    getCurrent((succ,res)=>{
      if(succ){
        if(res.status===0){
          console.error(res.message)
        }else{
          setCurrentLocations(res.address.id)
        }
      }else{
        console.error(res)
      }
    })
  };
  const [purchased, setPurchased] = useState(false);

  const closeModalHandler = () => {
    setPurchased(false);
  };
  const RemoveMapHandler = (data) => {
    setPurchased(true);
    setIdRemove(data.id);
  };
  const RemoveLocation = () => {
    let MapId = {
      id: IdRemove,
    };
    RemoveAddress(MapId, (succ, res) => {
      if (!succ) {
        errorToast(res.message);
      } else {
        succToast(res.message);
        setPurchased(false);
        showData();
      }
    });
  };
  const EdtieHandler = (data) => {
    history.push({ pathname: "/UpdateAddress", state: data.id });
  };

  // const EdtieInfoHandler = (data) => {
  //   let info={
  //     id:data.id
  //   }
  //   AddressDetailPostApi(info,res=>{
  //     history.push({ pathname: "/updateaddressinfo", state: res.address});
  //   })
  // };

  const onchangeValue = (e) => {
    setMapid(e.target.value);
    setCurrentLocations(e.target.value);
  };
  const UserMapLocation = () => {
    setDisable(true);
    let idMap = {
      id: Mapid,
    };
    selectAddress(idMap, (succ, res) => {
      if (res.status === 0) {
        setDisable(false);
        errorToast("مشکلی پیش آمده!");
      } else {
        succToast(res.message);
      }
    });
  };
  
  let Loading = null;
  if (Locations === undefined) {
    Loading = <LoadingComponet />;
  }else if(Locations?.length===0){
    Loading = <p className={Style.emptyLocation}>آدرسی یافت نشد!</p>
  } else {
    Loading = (
      <>
        <div className={Style.AddressHolder}>
          {Locations.map((item) => {
            return (
              <section key={item.id} className={Style.userAddress}>
                <label
                  className={Style.userAddress__rightPart}
                  htmlFor={item.id}
                >
                  <div className={Style.AddressCheck}>
                    <input
                      type="radio"
                      name="Address"
                      id={item.id}
                      value={item.id}
                      checked={item.id === currentLocations}
                      onChange={(e) => onchangeValue(e)}
                    />
                  </div>
                  <div className={Style.AddressText}>{item.title}</div>
                </label>
                <div className={Style.AddressText}>
                  {item.province_name +
                    "," +
                    item.city_name +
                    "," +
                    "خیابان: " +
                    item.street +
                    "," +
                    "کوچه: " +
                    item.alley +
                    "," +
                    "محله: " +
                    item.district +
                    "," +
                    "ساختمان: " +
                    item.apartment_name +
                    "," +
                    "واحد: " +
                    item.apartment_number +
                    "," +
                    "پلاک: " +
                    item.plate +
                    "," +
                    item.description}
                </div>
                <div className={Style.userAddress__leftPart}>
                  <div
                    onClick={() => EdtieHandler(item)}
                    className={Style.EditeMap}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                    <p> ویرایش </p>
                  </div>
                  {/* <div className={Style.EditeMap} onClick={() => EdtieInfoHandler(item)}>
                    <FontAwesomeIcon
                      icon={faEdit}
                    />
                    <p> اطلاعات</p>
                  </div> */}
                  <div
                    className={Style.removeMap}
                    onClick={() => RemoveMapHandler(item)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                    <p>حذف</p>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
        <div>
          <Button
            ClassBtn={"confrimBtn"}
            Value={"تایید"}
            ClickHandler={UserMapLocation}
            disabledprops={disable}
          />
        </div>
      </>
    );
  }
  return (
    <section className={Style.PageHolder}>
      <Modal show={purchased} modalClose={closeModalHandler} translate={40}>
        <div className={Style.RemoveConfirm}>
          <p>آیا از حذف آدرس موردنظر مطمئنید؟</p>
          <div className={Style.optionsHolder}>
            <p className={Style.ConfirmRemove} onClick={RemoveLocation}>
              بله
            </p>
            <p className={Style.CancelRemove} onClick={closeModalHandler}>
              خیر
            </p>
          </div>
        </div>
      </Modal>
      <div className={Style.ComponentHolder}>
        <div></div>
        <h3>انتخاب آدرس</h3>
        <Link className={Style.back} to={"/"}>
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
      <div className={Style.AddNewAddress}>
        <Link to="/addnewaddress" style={{ color: "#c20c64" }}>
          <p style={{marginBottom:'0'}}> آدرس جدید  </p>
          <FontAwesomeIcon icon={faPlus} />
        </Link>
      </div>
      {Loading}
    </section>
  );
};
export default ChangeAddress;
